module.exports = __webpack_public_path__ + "static/media/Agri-Transporter Infographic Desktop 22-02-2024 C.61c48fc3.gif";